var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRaLogoWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1440 384.8",
    style: {
      enableBackground: "new 0 0 1440 384.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ffffff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.5,162.6c0,32.3-14.1,52.7-42.3,61.1l51.3,71.2h-42.1L76.6,229H33.1v65.9H0v-196h72.9 c29.9,0,51.3,5,64.2,15.1C150,124.2,156.5,140.3,156.5,162.6z M112.5,190.3c6.7-5.8,10.1-15.1,10.1-27.9c0-12.8-3.5-21.6-10.4-26.4 c-6.9-4.8-19.3-7.2-37-7.2H33.1V199h41.2C93,199,105.7,196.1,112.5,190.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M407.1,124.7c-9.6,0-17.5,2-23.7,5.9c-6.2,3.9-9.3,9.9-9.3,17.8c0,7.9,3.1,14,9.3,18.2 c6.2,4.2,19.3,8.7,39.4,13.6c20.1,4.9,35.2,11.7,45.4,20.5c10.2,8.8,15.3,21.7,15.3,38.8c0,17.1-6.5,31-19.3,41.6 c-12.9,10.7-29.8,16-50.8,16c-30.7,0-57.9-10.6-81.6-31.7l20.8-25c19.8,17.2,40.4,25.8,61.7,25.8c10.7,0,19.1-2.3,25.4-6.9 c6.3-4.6,9.4-10.7,9.4-18.2c0-7.6-2.9-13.5-8.8-17.7c-5.9-4.2-16-8-30.4-11.5c-14.4-3.5-25.3-6.6-32.8-9.5 c-7.5-2.9-14.1-6.7-19.9-11.4c-11.6-8.8-17.4-22.2-17.4-40.4s6.6-32.1,19.8-41.9c13.2-9.8,29.5-14.7,48.9-14.7 c12.5,0,25,2.1,37.3,6.2c12.3,4.1,23,9.9,32,17.4l-17.7,25c-5.8-5.2-13.7-9.5-23.6-12.9C426.5,126.4,416.7,124.7,407.1,124.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M690.2,98.9V130H585.6v51.9h93.9v29.4h-93.9v52.4h108v31.1H552.5v-196H690.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M868.7,250.3l-19.6,44.6h-35.3l86.4-196h35.3l86.4,196h-35.3l-19.6-44.6H868.7z M953.4,219.8L917.8,139 l-35.6,80.8H953.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1233.6,162.6c0,32.3-14.1,52.7-42.3,61.1l51.3,71.2h-42.1l-46.8-65.9h-43.5v65.9h-33.1v-196h72.9 c29.9,0,51.3,5,64.2,15.1C1227.1,124.2,1233.6,140.3,1233.6,162.6z M1189.6,190.3c6.7-5.8,10.1-15.1,10.1-27.9 c0-12.8-3.5-21.6-10.4-26.4c-6.9-4.8-19.3-7.2-37-7.2h-42.1V199h41.2C1170.1,199,1182.8,196.1,1189.6,190.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1380.5,129.2v165.7h-33.1V129.2H1288V98.9h152v30.3H1380.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.9,
    y: 0,
    className: "st0",
    width: 29.1,
    height: 384.8
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaLogoWhite);
export default __webpack_public_path__ + "static/media/ra-logo-white.e252c360776d3dee4a5f223d11b56bec32cafdf492d21518c71cb1bdf51d5945.svg";
export { ForwardRef as ReactComponent };